export class Scss {

    public static variable(name: string): string {
        const bodyStyles = window.getComputedStyle(document.body);
        return bodyStyles?.getPropertyValue(`--scss-${name}`);
    }

}
